import { AmountScreen } from './AmountScreen/AmountScreen';
import { BusinessAddressScreen } from './BusinessAddressScreen/BusinessAddressScreen';
import { CompanyScreen } from './CompanyScreen/CompanyScreen';
import { DateOfBirthScreen } from './DateOfBirthScreen/DateOfBirthScreen';
import { DurationScreen } from './DurationScreen/DurationScreen';
import { EmailScreen } from './EmailScreen/EmailScreen';
import { FoundingDateScreen } from './FoundingDateScreen/FoundingDateScreen';
import { HomeAddressScreen } from './HomeAddressScreen/HomeAddressScreen';
import { LoadingScreen } from './LoadingScreen/LoadingScreen';
import { NameScreen } from './NameScreen/NameScreen';
import { OfferScreen } from './OfferScreen/OfferScreen';
import { PhoneScreen } from './PhoneScreen/PhoneScreen';
import { PrivacyConsentScreen } from './PrivacyConsentScreen/PrivacyConsentScreen';
import { PurposeScreen } from './PurposeScreen/PurposeScreen';
import { TurnoverScreen } from './TurnoverScreen/TurnoverScreen';
import { TScreenDef } from './types';

// The flow definition (DIT-671): screen order + wiring. Each `Content` is a
// content-only component from its own folder; `isAnswered` is a stub (() => false)
// until each screen sub-task (Tasks 1–5) wires its real saved-state check.
// Order is the single source of truth for the sequence; the 0.6 nav hook reads it.
// `duration` (DIT-709) sits between amount and purpose → 15 screens total.
export const SCREEN_REGISTRY: TScreenDef[] = [
  {
    id: 'amount',
    stage: 'Get started',
    Content: AmountScreen,
    isAnswered: (form) => !!form.amount,
  },
  {
    id: 'duration',
    stage: 'Get started',
    Content: DurationScreen,
    isAnswered: (form) => !!form.loanDuration,
  },
  {
    id: 'purpose',
    stage: 'Get started',
    Content: PurposeScreen,
    isAnswered: (form) => !!form.loanPurpose,
  },
  {
    id: 'email',
    stage: 'Get started',
    Content: EmailScreen,
    isAnswered: (form) => !!form.email,
  },
  {
    id: 'company',
    stage: 'Business details',
    Content: CompanyScreen,
    isAnswered: () => false,
  },
  {
    id: 'business-address',
    stage: 'Business details',
    Content: BusinessAddressScreen,
    isAnswered: () => false,
  },
  {
    id: 'founding-date',
    stage: 'Business details',
    Content: FoundingDateScreen,
    isAnswered: () => false,
  },
  {
    id: 'turnover',
    stage: 'Business details',
    Content: TurnoverScreen,
    isAnswered: () => false,
  },
  {
    id: 'name',
    stage: 'Personal details',
    Content: NameScreen,
    isAnswered: () => false,
  },
  {
    id: 'date-of-birth',
    stage: 'Personal details',
    Content: DateOfBirthScreen,
    isAnswered: () => false,
  },
  {
    id: 'phone',
    stage: 'Personal details',
    Content: PhoneScreen,
    isAnswered: () => false,
  },
  {
    id: 'home-address',
    stage: 'Personal details',
    Content: HomeAddressScreen,
    isAnswered: () => false,
  },
  {
    id: 'consent',
    stage: 'Personal details',
    Content: PrivacyConsentScreen,
    isAnswered: () => false,
  },
  {
    id: 'loading',
    stage: 'Offer',
    Content: LoadingScreen,
    isAnswered: () => false,
  },
  {
    id: 'offer',
    stage: 'Offer',
    Content: OfferScreen,
    isAnswered: () => false,
  },
];
